import { notificationCategoryNumber } from './components/common/notification-category-tag';
import {
  RecurrenceFrequencyEnum,
  RecurrenceFrequencyEnumValue,
} from './components/job/types/recurrence-frequency-enum';
import {
  JobCommentTypeEnum,
  JobCommentTypeEnumValue,
} from './components/job/types/job-comment-type-enum';
import {
  TaskStatusEnum,
  TaskStatusEnumValue,
} from './components/work/types/task-status-enum';
import {
  JobStatusEnum,
  JobStatusEnumValueType,
} from './components/job/types/job-status-enum';
import {
  WorkViewEnum,
  WorkViewLabelType,
} from './components/work/types/work-view-enum';
import { NotificationCategoriesEnum } from './components/notifications/notification/notification-types/notifications-categories-enum';

// job statuses

export const jobStatuses = [
  { id: JobStatusEnum.valuesEnum.NotStarted, value: 1 },
  { id: JobStatusEnum.valuesEnum.InProgress, value: 2 },
  { id: JobStatusEnum.valuesEnum.Completed, value: 3 },
  { id: JobStatusEnum.valuesEnum.Closed, value: 4 },
];

const jobStatusMapById = new Map(
  jobStatuses.map(({ id, value }) => [id, value])
);
export const getJobStatusNumber = (id: JobStatusEnumValueType) =>
  jobStatusMapById.get(id)!;

const jobStatusMapByValue = new Map(
  jobStatuses.map(({ id, value }) => [value, id])
);
export const getJobStatus = (value: number) => jobStatusMapByValue.get(value)!;

// task statuses

export const taskStatuses = [
  { id: TaskStatusEnum.valuesEnum.NotStarted, value: 1 },
  { id: TaskStatusEnum.valuesEnum.InProgress, value: 2 },
  { id: TaskStatusEnum.valuesEnum.OnHold, value: 3 },
  { id: TaskStatusEnum.valuesEnum.ReadyForReview, value: 4 },
  { id: TaskStatusEnum.valuesEnum.Done, value: 5 },
  { id: TaskStatusEnum.valuesEnum.Cancelled, value: 6 },
];

const taskStatusMapById = new Map(
  taskStatuses.map(({ id, value }) => [id, value])
);
export const getTaskStatusNumber = (id: TaskStatusEnumValue) =>
  taskStatusMapById.get(id)!;

const taskStatusMapByValue = new Map(
  taskStatuses.map(({ id, value }) => [value, id])
);
export const getTaskStatus = (value: number) =>
  taskStatusMapByValue.get(value)!;

// work views

export const workViews = [
  { id: WorkViewEnum.valuesEnum.TaskList, value: 1 },
  { id: WorkViewEnum.valuesEnum.TaskBoard, value: 2 },
  { id: WorkViewEnum.valuesEnum.JobList, value: 3 },
  { id: WorkViewEnum.valuesEnum.JobBoard, value: 4 },
  { id: WorkViewEnum.valuesEnum.JobTaskList, value: 5 },
  { id: WorkViewEnum.valuesEnum.JobTaskBoard, value: 6 },
];

const workViewMapById = new Map(workViews.map(({ id, value }) => [id, value]));
export const getWorkViewNumber = (id: WorkViewLabelType) =>
  workViewMapById.get(id)!;

const workViewMapByValue = new Map(
  workViews.map(({ id, value }) => [value, id])
);
export const getWorkView = (value: number) => workViewMapByValue.get(value)!;

// job comment types
export const jobCommentTypes = [
  { id: JobCommentTypeEnum.valuesEnum.Comment, value: 1 },
  { id: JobCommentTypeEnum.valuesEnum.SignOffRequested, value: 2 },
  { id: JobCommentTypeEnum.valuesEnum.SignOffApproved, value: 3 },
  { id: JobCommentTypeEnum.valuesEnum.SignOffDeclined, value: 4 },
  { id: JobCommentTypeEnum.valuesEnum.SignOffWithdrawn, value: 5 },
  { id: JobCommentTypeEnum.valuesEnum.SignOffRevoked, value: 6 },
];

const jobCommentTypesMapById = new Map(
  jobCommentTypes.map(({ id, value }) => [id, value])
);
export const getJobCommentTypeNumber = (id: JobCommentTypeEnumValue) =>
  jobCommentTypesMapById.get(id)!;

const jobCommentTypeMapByValue = new Map(
  jobCommentTypes.map(({ id, value }) => [value, id])
);
export const getJobCommentType = (value: number) =>
  jobCommentTypeMapByValue.get(value)!;

// Was going to use these, but they're the wrong meaning semantically
// We want the comment ones to use the same colours as the notice panels
// But we want the normal comment comments to be grey
// Unless they're by the current author, in which case we want accent
// type JobCommentColor = {
//   [key in JobCommentType]: Tone | undefined;
// };

// export const jobCommentColors: JobCommentColor = {
//   [JobCommentType.Comment]: 'default',
//   [JobCommentType.SignOffRequested]: 'attention',
//   [JobCommentType.SignOffApproved]: 'resolved',
//   [JobCommentType.SignOffDeclined]: 'rejected',
//   [JobCommentType.SignOffWithdrawn]: 'default',
//   [JobCommentType.SignOffRevoked]: 'attention',
// };

// sign off statuses
// notification
const notificationCategory = [
  {
    id: notificationCategoryNumber.Job,
    value: NotificationCategoriesEnum.valuesEnum.Job,
  },
  {
    id: notificationCategoryNumber.Task,
    value: NotificationCategoriesEnum.valuesEnum.Task,
  },
  {
    id: notificationCategoryNumber.Mention,
    value: NotificationCategoriesEnum.valuesEnum.Mention,
  },
];

const notificationCategoryMapById = new Map(
  notificationCategory.map(({ id, value }) => [id, value])
);

export const getNotificationCategoryValue = (id: number) =>
  notificationCategoryMapById.get(id)!;

// recurrence
const RecurrenceFrequency = RecurrenceFrequencyEnum.valuesEnum;

const recurrenceFrequency = [
  { id: 107, value: RecurrenceFrequency.SevenDays, label: 'week' },
  { id: 114, value: RecurrenceFrequency.FourteenDays, label: 'fortnight' },
  { id: 1, value: RecurrenceFrequency.OneMonth, label: 'month' },
  { id: 2, value: RecurrenceFrequency.TwoMonths, label: '2 months' },
  { id: 3, value: RecurrenceFrequency.ThreeMonths, label: '3 months' },
  { id: 6, value: RecurrenceFrequency.SixMonths, label: '6 months' },
  { id: 12, value: RecurrenceFrequency.TwelveMonths, label: '12 months' },
];

const recurrenceFrequencyMapById = new Map(
  recurrenceFrequency.map(({ id, value }) => [id, value])
);

export const getRecurrenceFrequency = (
  recurrenceFrequency?: number | RecurrenceFrequencyEnumValue | null
): RecurrenceFrequencyEnumValue | undefined => {
  if (typeof recurrenceFrequency === 'number') {
    return recurrenceFrequencyMapById.get(recurrenceFrequency);
  }

  if (RecurrenceFrequencyEnum.isAValue(recurrenceFrequency)) {
    return recurrenceFrequency;
  }

  return undefined;
};

const recurrenceFrequencyMapByIdLabel = new Map(
  recurrenceFrequency.map(({ id, label }) => [id, label])
);

const recurrenceFrequencyMapByValueLabel = new Map(
  recurrenceFrequency.map(({ value, label }) => [value, label])
);

export const getRecurrenceFrequencyLabel = (
  by: number | RecurrenceFrequencyEnumValue
) => {
  if (typeof by === 'number') {
    return recurrenceFrequencyMapByIdLabel.get(by);
  }
  return recurrenceFrequencyMapByValueLabel.get(by);
};

export const INACTIVE_USER_VALUE = 'inactive';
export const UNALLOCATED_USER_VALUE = 'unallocated';
